<template>
  <div class="welcome-section px-6 2xl:px-20 py-32 max-w-2k mx-auto">
    <h1>{{ $t('NNP_SUBPROCESSORS_LIST') }}</h1>
    
    <p>{{ $t('NNP_SUBPROCESSORS_DESC_1') }}</p>
    <p>{{ $t('NNP_SUBPROCESSORS_DESC_2') }}</p>
    <p>{{ $t('NNP_SUBPROCESSORS_DESC_3') }}</p>
    <p>{{ $t('NNP_SUBPROCESSORS_DESC_4') }}</p>

    <i18n-t tag="p" keypath="NNP_SUBPROCESSORS_DESC_4">
      <template #privacy_policy>
        <nuxt-link :to="localePath('/legal/privacy-policy')">
          {{ $t('privacy_policy') }}
        </nuxt-link>
      </template>
    </i18n-t>
    <p>{{ $t('NNP_SUBPROCESSORS_DESC_5') }}</p>

    <div class="block mt-12">
      <table>
        <thead>
          <tr>
            <th>{{ $t('VENDOR_NAME') }}</th>
            <th>{{ $t('LOCATION') }}</th>
            <th>{{ $t('PORPUSE') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="value in data" :key="value.id">
            <td>{{ value.name }}</td>
            <td>{{ $t(`COUNTRY_${value.country_code}`) }}</td>
            <td>{{ $t(value.purpose?.toUpperCase()) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script lang="ts" setup>
const { t: $t } = useI18n()

import type { IPayloadCmsSubProcessors } from '~~/server/api/legal/types';


// ---------------------------------------
// Hooks
// ---------------------------------------

const localePath = useLocalePath();
const { t } = useI18n();

const {status, error, data } = await useFetch<IPayloadCmsSubProcessors['docs']>(`/api/legal/subprocessors`,
  {
    key: `subprocessorsList`,
    lazy: false,
    immediate: true,
  }
);

// ---------------------------------------
// State
// ---------------------------------------

// ---------------------------------------
// Meta
// ---------------------------------------

useHead({
  title: t('NNP_SUBPROCESSORS_LIST'),
  titleTemplate: '%s',
  meta: [
    { content: $t('NNP_SUBPROCESSORS_DESC'), name: 'description' },
    { content: $t('NNP_SUBPROCESSORS_KEYWORDS'), name: 'keywords' },
    { content: $t('NNP_SUBPROCESSORS_LIST'), property: 'og:title' },
    { content: $t('NNP_SUBPROCESSORS_DESC'), property: 'og:description' },
  ],
});
</script>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border-bottom: 1px solid #000;
  text-align: left;
  padding: 16px;
}
</style>
